module.exports = __webpack_public_path__ + "mw.svg?8627c92dc660e33b047a1ae2efe17cf9";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/4x3/mw.svg
// module id = 1265
// module chunks = 0